import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { VEHICLE_VALUATION_RESOURCE } from "./use-vehicle-valuation-search.query";

export const VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_OPERATION = "vehicle-data-repair" as const;
export const VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_API_PATH =
  `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/${VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_OPERATION}` as const;

export type VehicleValuationVehicleDataRepairStatusResponse =
  paths[typeof VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useVehicleValuationVehicleDataRepairStatusQuery(uuid: string, enabled: boolean) {
  return useQuery({
    enabled: Boolean(uuid) && enabled,
    queryKey: [VEHICLE_VALUATION_RESOURCE, uuid, VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_OPERATION],
    queryFn: async () => {
      const apiPath = VEHICLE_VALUATION_VEHICLE_DATA_REPAIR_API_PATH.replace("{uuid}", uuid);
      const response = await alphartisApiAxios.get<VehicleValuationVehicleDataRepairStatusResponse>(apiPath);

      return response.data;
    },
  });
}
